import React, { useEffect, useState } from 'react';
import {
  Button as MUIButton,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Chip
} from '@material-ui/core';
import { push } from 'connected-react-router';
import mixpanel from '../../../utils/mixpanel';
import { userTypes } from '../../../constants/users';
import { teacherRoutes, parentRoutes, schoolAdminRoutes, districtAdminRoutes } from '../../../constants/routes';
import ChuckContainer from '../../../components/chuck/ChuckContainer';
import { connect } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { withRouter } from 'react-router';
import View from '../../../components/view/View';
import Button from '../../../components/button/Button';
import { ResourceActionsAsync } from './state/resourceHub-actions.async';
import { makeStyles } from '@material-ui/core/styles';
import DownloadCircle from '@material-ui/icons/CloudDownloadRounded';
import { useSelector } from 'react-redux';
import LinkIcon from '@material-ui/icons/LinkRounded';
import {
  ResourceState,
  resourceTypes
} from './state/resourceHub.types';

const useStyles = makeStyles({
  card: {
    height: '100%',
    width: '100%',
    maxHeight: 450,
    maxWidth: 450,
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer'
  },
  cardMedia: {
    maxWidth: '100%',
    display: 'flex',
    justifyContent: 'center',
    margin: 'auto',
    flexDirection: 'column',
  },
  cardLayout: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    justifyContent: 'space-between'
  },
  extraPadding: {
    padding: 20
  },
  imgHeight: {
    maxHeight: 230,
    overflow: 'hidden'
  },
  container: {
    padding: 20,
    justifyContent: "center"
  },
  tag: {
    marginBottom: 10
  }
});

interface ResourceMedia {
  title: string;
  imageLink: string;
  body: string;
  resourceId: string;
  userAccessType: string;
  type: string;
  resourceLink: string;
  classCode: any;
  additionalActions?: () => void;
  tracker?: () => void;
  push: (tracker: any) => void;
}

const ResourceMedia: React.FC<ResourceMedia> = ({
  title,
  imageLink,
  body,
  resourceId,
  push,
  userAccessType,
  type,
  classCode,
  resourceLink
}: ResourceMedia) => {
  const styles = useStyles();
  const [linkRedirect, setLinkRedirect] = useState(false);
  const [link] = useState(() => {
    switch (userAccessType) {
      case userTypes.teacher: {
        if (classCode) {
          return teacherRoutes.resourceHubInfoClass.replace(
            ':resourceId/class/:classCode',
            resourceId + '/class/' + classCode as string);
        } else {
          return teacherRoutes.resourceHubInfo.replace(
            ':resourceId',
            resourceId as string);
        }
      }
      case userTypes.parent: {
        return parentRoutes.resourceHubInfo.replace(
          ':resourceId',
          resourceId as string
        );
      }
      case userTypes.districtAdmin: {
        return districtAdminRoutes.resourceHubInfo.replace(
          ':resourceId',
          resourceId as string
        );
      }
      case userTypes.schoolAdmin: {
        return schoolAdminRoutes.resourceHubInfo.replace(
          ':resourceId',
          resourceId as string
        );
      }
    }
  });

  const [resourceStatus] = useState(() => {
    switch (type) {
      case resourceTypes.download: {
        return 'Download Available';
      }
      case resourceTypes.video: {
        return 'Video Available';
      }
      case resourceTypes.readAloud: {
        return 'Read Aloud';
      }
      case resourceTypes.linkRedirect: {
        setLinkRedirect(true);
        return 'Link Redirect';
      }
    }
  });

  return (
    <Card
      className={styles.card}
      onClick={() => {
        mixpanel.track('Resource Hub Card Clicked');
        if (type === resourceTypes.linkRedirect) {
          window.open(resourceLink, title);
        } else {
          push(link);
        }
      }}
    >
      <div className={styles.imgHeight} >
        <CardMedia
          component="img"
          alt={`${title}-icon`}
          title={title}
          image={imageLink}
          className={styles.cardMedia}
        />
      </div>

      <div
        className={styles.cardLayout}
      >
        {/* If linkRedirect is true body is hidden and DownloadCircle is replaced with a link icon, signifying link redirect */}
        <CardContent>
          <div >
            <Chip icon={linkRedirect ? <LinkIcon /> : <DownloadCircle />} label={resourceStatus} className={styles.tag} variant="outlined" />
          </div>
          <Typography variant="h5" component="h2">
            {title}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p" hidden={linkRedirect}>
            {body}
          </Typography>
        </CardContent>
      </div>

    </Card>
  );
};


const ResourceView: React.FC<any> = (props: any) => {
  const styles = useStyles();
  const dispatch = useAppDispatch();
  const currentClass = useSelector((state: any) => state.class.currentClass);
  const classCode = useSelector((state: any) => currentClass.code);
  const userData = useSelector((state: any) => state.userData);
  const userType = userData.userType;
  const resourceState = useAppSelector<ResourceState>(
    state => state.resources
  );

  const resourceList = resourceState.all
  useEffect(() => {
    dispatch(ResourceActionsAsync.getAllResources(userType));
  }, []);


  const trimBody = (body: string) => {
    if (body === undefined || !body.length) {
      return ''
    }
    return body.slice(0, 150).concat('...')
  }
  mixpanel.track('Resource Hub accessed');
  return (
    <div>
      <View title={'Resource Hub'} />
      {/* <Grid container item lg={10} spacing={1}  >
        <Button style={{marginRight: "10px", marginLeft: "10px"}}
                      primary onClick={() => (console.log('Videos'))}>
          Videos
        </Button>
        <Button style={{marginRight: "10px", marginLeft: "10px"}}
                primary onClick={() => (console.log('Downloads'))}>
          Downloads
        </Button>
        <Button style={{marginRight: "10px", marginLeft: "10px"}}
                primary onClick={() => (console.log('Read Aloud'))}>
          Read Aloud
        </Button>
      </Grid> */}

      <ChuckContainer />
      <Grid container spacing={5} className={styles.container} alignItems="stretch" >
        {resourceList.map((resource: any) => {
          return (
            <>
              <Grid className={styles.extraPadding}>
                <ResourceMedia
                  title={resource.title}
                  body={trimBody(resource.description)}
                  imageLink={resource.thumbnail}
                  push={props.push}
                  resourceId={resource._id}
                  userAccessType={userType}
                  type={resource.type[0]}
                  resourceLink={resource.link}
                  classCode={classCode}
                />
              </Grid>
            </>
          );
        })}
      </Grid>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  class: state.class
});

const mapActionsToProps = {
  push
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(withRouter(ResourceView));
